import { memo } from 'preact/compat';

import { useSelector } from '@/redux/helper';
import { profileBackground } from '@/shared/profileGradients';
import { getIconKeys, getIconUrl } from '@/shared/profileIcons';

/** An icon key, or the URL an icon was saved as before keys; an unknown key draws the first icon. */
const iconSource = (icon: string | null | undefined): string =>
  icon?.endsWith('.svg') ? icon : getIconUrl(icon) || getIconUrl(getIconKeys()[0]);

interface AnimalIconProps {
  animalIcon?: string | null;
  color?: string | null;
  gradient?: string | null;
  /** The circle's diameter. */
  width?: number;
}

/** A user's animal on their colour. Without a colour, or without an animal, it draws the signed-in user's. */
const AnimalIcon = ({ animalIcon, color, gradient, width = 30 }: AnimalIconProps) => {
  const userProfile = useSelector((state) => state.user?.profile);

  return (
    <div
      className="flex shrink-0 items-center justify-center rounded-full p-1"
      style={{
        ...(color ? profileBackground(color, gradient) : profileBackground(userProfile?.color, userProfile?.gradient)),
        width,
        height: width,
      }}
    >
      <img src={iconSource(animalIcon || userProfile?.animalIcon)} alt="animal" className="size-full" />
    </div>
  );
};

export default memo(AnimalIcon);
